export const hideMobileKeyboard = (event: any) => {
  if (!event) return;
  event.blur();
};

export function isEmailValid(email: string): boolean {
  // Regex explanation:
  // ^                   : Start of the string
  // [a-zA-Z0-9._%+-]+   : Match one or more alphanumeric characters, dots, underscores, percent signs, plus or minus signs.
  // @                   : Literal '@' symbol
  // [a-zA-Z0-9.-]+      : Match one or more alphanumeric characters, dots or hyphens (for the domain part)
  // \.                  : Literal dot '.'
  // [a-zA-Z]{2,}        : Match two or more alphabetic characters (for the domain extension)
  // $                   : End of the string
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
}

export const isAdult = (birthDateString: string): boolean => {
  const sanitizedDate = birthDateString.replace(/(T.+)/gi, '');
  const [year, month, day] = sanitizedDate.split('-').map(Number);
  const birthDate = new Date(year, (month ?? 1) - 1, day ?? 1);

  const adultDate = new Date(birthDate);

  adultDate.setFullYear(adultDate.getFullYear() + 18);

  return new Date() >= adultDate;
};
